import React from 'react';
import { Button } from '../components/ui/Button';
import { Card, CardBody } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Building2, FileCheck, Clock, HeartPulse, CheckCircle } from 'lucide-react';
export function Partners() {
  return <div className="bg-white min-h-screen" data-id="element-747">
      {/* Header */}
      <div className="bg-primary-900 text-white py-20" data-id="element-748">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-749">
          <div className="max-w-3xl" data-id="element-750">
            <span className="text-primary-300 font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-751">
              For Healthcare Facilities & Providers
            </span>
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-752">
              A Reliable Extension of Your Care Team
            </h1>
            <p className="text-xl text-primary-100 mb-8" data-id="element-753">
              Partner with AccessRide to ensure your patients arrive safely, on
              time, and with the dignity they deserve. We handle the logistics
              so you can focus on care.
            </p>
            <Button size="lg" variant="secondary" data-id="element-754">
              Request a Partnership Packet
            </Button>
          </div>
        </div>
      </div>

      {/* Why Partner */}
      <div className="py-20 bg-warm-50" data-id="element-755">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-756">
          <div className="text-center mb-16" data-id="element-757">
            <h2 className="text-3xl font-bold text-warm-900 mb-4" data-id="element-758">
              Why Facilities Choose Us
            </h2>
            <p className="text-lg text-warm-600 max-w-2xl mx-auto" data-id="element-759">
              We understand the challenges of patient logistics. Missed
              appointments cost time, money, and impact health outcomes.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-760">
            <Card className="border-none shadow-md" data-id="element-761">
              <CardBody className="text-center p-6" data-id="element-762">
                <Clock className="w-10 h-10 text-primary-600 mx-auto mb-4" data-id="element-763" />
                <h3 className="text-xl font-bold text-warm-900 mb-2" data-id="element-764">
                  On-Time Reliability
                </h3>
                <p className="text-warm-600 text-sm" data-id="element-765">
                  Reduce missed appointments and late arrivals with our advanced
                  dispatch and routing technology.
                </p>
              </CardBody>
            </Card>
            <Card className="border-none shadow-md" data-id="element-766">
              <CardBody className="text-center p-6" data-id="element-767">
                <FileCheck className="w-10 h-10 text-primary-600 mx-auto mb-4" data-id="element-768" />
                <h3 className="text-xl font-bold text-warm-900 mb-2" data-id="element-769">
                  HIPAA Compliant
                </h3>
                <p className="text-warm-600 text-sm" data-id="element-770">
                  Strict adherence to privacy laws. Secure booking portals and
                  trained staff protect patient information.
                </p>
              </CardBody>
            </Card>
            <Card className="border-none shadow-md" data-id="element-771">
              <CardBody className="text-center p-6" data-id="element-772">
                <HeartPulse className="w-10 h-10 text-primary-600 mx-auto mb-4" data-id="element-773" />
                <h3 className="text-xl font-bold text-warm-900 mb-2" data-id="element-774">
                  Trained Staff
                </h3>
                <p className="text-warm-600 text-sm" data-id="element-775">
                  Drivers are CPR/First Aid certified and trained in safe
                  transfer techniques and patient sensitivity.
                </p>
              </CardBody>
            </Card>
            <Card className="border-none shadow-md" data-id="element-776">
              <CardBody className="text-center p-6" data-id="element-777">
                <Building2 className="w-10 h-10 text-primary-600 mx-auto mb-4" data-id="element-778" />
                <h3 className="text-xl font-bold text-warm-900 mb-2" data-id="element-779">
                  Dedicated Portal
                </h3>
                <p className="text-warm-600 text-sm" data-id="element-780">
                  Facility coordinators get access to a streamlined dashboard to
                  book, track, and manage all patient rides.
                </p>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>

      {/* Contract Services */}
      <div className="py-20" data-id="element-781">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-782">
          <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-783">
            <div className="lg:w-1/2" data-id="element-784">
              <h2 className="text-3xl font-bold text-warm-900 mb-6" data-id="element-785">
                Contract Transportation Solutions
              </h2>
              <p className="text-lg text-warm-600 mb-6" data-id="element-786">
                We offer customized contracts for hospitals, nursing homes,
                adult day centers, and dialysis clinics.
              </p>
              <ul className="space-y-4 mb-8" data-id="element-787">
                <li className="flex items-start" data-id="element-788">
                  <CheckCircle className="w-6 h-6 text-secondary-600 mr-3 flex-shrink-0" data-id="element-789" />
                  <div data-id="element-790">
                    <strong className="block text-warm-900" data-id="element-791">
                      Dedicated Routes
                    </strong>
                    <span className="text-warm-600" data-id="element-792">
                      Set daily or weekly schedules for recurring patient needs.
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-793">
                  <CheckCircle className="w-6 h-6 text-secondary-600 mr-3 flex-shrink-0" data-id="element-794" />
                  <div data-id="element-795">
                    <strong className="block text-warm-900" data-id="element-796">
                      Streamlined Billing
                    </strong>
                    <span className="text-warm-600" data-id="element-797">
                      Consolidated monthly invoicing or direct
                      insurance/Medicaid billing where applicable.
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-798">
                  <CheckCircle className="w-6 h-6 text-secondary-600 mr-3 flex-shrink-0" data-id="element-799" />
                  <div data-id="element-800">
                    <strong className="block text-warm-900" data-id="element-801">
                      Priority Dispatch
                    </strong>
                    <span className="text-warm-600" data-id="element-802">
                      Contracted facilities receive priority status for urgent,
                      same-day transport needs (like hospital discharges).
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            <div className="lg:w-1/2 w-full" data-id="element-803">
              <Card className="shadow-xl" data-id="element-804">
                <CardBody className="p-8" data-id="element-805">
                  <h3 className="text-2xl font-bold text-warm-900 mb-6" data-id="element-806">
                    Contact Our Provider Relations Team
                  </h3>
                  <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-807">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-808">
                      <Input label="First Name" required data-id="element-809" />
                      <Input label="Last Name" required data-id="element-810" />
                    </div>
                    <Input label="Facility/Organization Name" required data-id="element-811" />
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-812">
                      <Input label="Work Email" type="email" required data-id="element-813" />
                      <Input label="Direct Phone" type="tel" required data-id="element-814" />
                    </div>
                    <Input label="How can we help?" multiline placeholder="Tell us about your facility's transportation volume and needs..." data-id="element-815" />
                    <Button type="submit" fullWidth size="lg" className="mt-4" data-id="element-816">
                      Submit Inquiry
                    </Button>
                  </form>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>;
}